import { INDEX_LINK } from "./constants";

export function indexLink(index, router) {
  return {
    type: INDEX_LINK,
    indexLink: index,
    router
  };
}
